import { title } from "process";
import { MODEL_CONSTANTS } from "./constant";

const initalState = {
  appModal: {
    open: false,
    options: {
      fullScreen: false,
      childTemplate: null,
    },
  },
  pannelStatus: true,
  pageLoader: false,
  content: "Loading...",
  toastModal: {
    open: false,
    content: null,
    lifetime: 5000
  },
};

export const modalReducer = (state = initalState, action: any) => {
  switch (action.type) {
    case MODEL_CONSTANTS.SHOW_MODAL:
      return {
        ...state,
        appModal: {
          open: true,
          options: action.payload,
        },
      };
    case MODEL_CONSTANTS.HIDE_MODAL:
      return {
        ...state,
        appModal: {
          open: false,
        },
      };
    case MODEL_CONSTANTS.PANEL_OPEN:
      return {
        ...state,
        pannelStatus: true,
      };
    case MODEL_CONSTANTS.PANEL_CLOSE:
      return {
        ...state,
        pannelStatus: false,
      };
    case MODEL_CONSTANTS.SHOW_LOADER:
      return {
        ...state,
        pageLoader: true,
        content: action.payload || null,
      };
    case MODEL_CONSTANTS.HIDE_LOADER:
      return {
        ...state,
        pageLoader: false,
        content: null,
      };
    case MODEL_CONSTANTS.SHOW_TOAST:
      return {
        ...state,
        toastModal: {
          open: true,
          type: action.payload?.type,
          content: action.payload?.content,
          lifetime: action.payload?.lifetime,
          title: action.payload?.title,
          subtitle: action.payload?.subtitle,
        },
      };
    case MODEL_CONSTANTS.HIDE_TOAST:
      return {
        ...state,
        toastModal: {
          open: false,
        },
      };
    default:
      return state;
  }
};